module.exports = __webpack_public_path__ + "img/mini_program.f93341c4.jpg";